import type { Decoder } from 'io-ts/Decoder';
import { array, intersect, literal, struct, union } from 'io-ts/Decoder';

import { EqualsType } from '../../api/generic/search/filter/EqualsType';
import { Id as CustomerId } from '../../customer/Id';
import {
	AncillaryItems,
	Client,
	ClientType,
	CompletionState,
	Country,
	DateFilter,
	DifficultyRatingFilter,
	JobType,
	Organization,
	RequestType,
	RequirementsJoined,
	SubAncillaryItems,
	User,
} from '../filter-request';

const withField = <Field extends string, A>(
	field: Field,
	decoder: Decoder<unknown, A>
): Decoder<unknown, { field: Field } & A> => intersect(decoder)(struct({ field: literal(field) }));

export const FilterRequest = array(
	union(
		withField('country', Country),
		// org
		withField('organization', Organization),
		// clientType
		withField('designClientType', ClientType),
		// client
		withField('designClient', Client),
		// customer
		struct({
			field: literal('customer'),
			equalsType: EqualsType,
			values: array(CustomerId),
		}),
		withField('owner', User),
		withField('jobType', JobType),
		withField('requestType', RequestType),
		withField('transactionDifficultyRating', DifficultyRatingFilter),
		withField('transactionRequirementJoined', RequirementsJoined),
		// Whole-house ancillary / sub-ancillary takeoff filters (contains-any).
		withField('transactionAncillaryItems', AncillaryItems),
		withField('transactionSubAncillaryItems', SubAncillaryItems),
		// "Show" — the lifecycle filter: Completed at-least-once / Completed /
		// In progress / Cancelled. Replaces the removed drawing-status barrel.
		withField('completionState', CompletionState),
		withField('transactionCreatedAt', DateFilter),
		withField('transactionDesignCompletedFirstAt', DateFilter),
		withField('transactionDesignCompletedAt', DateFilter),
		withField('transactionDesignReworkCompletedAt', DateFilter)
	)
);
